import React, { useEffect, useState } from 'react';
import useOpoFiles from '@nkr/store/opo/hooks/use-opo-files';
import { Button, Modal, Panel, Table, Well } from 'react-bootstrap';
import { FileDocumentType } from '@nkr/enums/document-type';
import FileUpload from '@nkr/components/file-upload';
import { DropEvent, FileRejection } from 'react-dropzone';
import BootstrapCard from '@nkr/components/bootstrap-card';

interface IProps {
    show: boolean,
    opoId: number,
    opoNkrName: string,
    onClose: () => void
}

const OpoFiles = ({ show, opoId, opoNkrName, onClose }: IProps) => {
    const { list, loading, error, refresh, upload } = useOpoFiles(opoId);
    const [uploadFile, setUploadFile] = useState<{ show: boolean, type: FileDocumentType, typeDescription: string }>({ show: false, type: null, typeDescription: '' });
    const [files, setFiles] = useState<File[]>([]);

    useEffect(() => {
        if (!show) {
            setUploadFile({ show: false, type: null, typeDescription: '' });
            setFiles([]);
        }
    }, [show]);

    const handleFileDropped = (acceptedFiles: File[], fileRejections: FileRejection[], event: DropEvent) => {
        setFiles(acceptedFiles);
    };

    const handleRemoveFile = (name: string) => {
        setFiles([]);
    };

    const handleUpload = () => {
        upload(opoId, uploadFile.type, files[0]).then(response => {
            refresh();
            setFiles([]);
            setUploadFile({ show: false, type: null, typeDescription: '' });
        });
    };

    console.log(list)

    return (
        <Modal backdrop='static' bsSize='lg' show={show} onHide={onClose}>
            <Modal.Header closeButton>OPO File Management for <strong>{opoNkrName}</strong></Modal.Header>
            <Modal.Body>
                {/* <Table bordered condensed>
                    <thead>
                        <tr>
                            <th>Type</th>
                            <th>File</th>
                            <th>Uploaded</th>
                            <th>Uploaded By</th>
                        </tr>
                    </thead>
                    <tbody>
                        {list.map((item, index) =>
                            <>
                                <tr key={'opo-file-group' + index}>
                                    <td colSpan={4}>
                                        <div style={{ display: 'flex', alignItems: 'center' }}>
                                            <div style={{ marginRight: 10 }}>{item.documentType}</div>
                                            <Button bsSize='xs' disabled={uploadFile.show} onClick={() => setUploadFile({ show: true, type: item.documentTypeId, typeDescription: item.documentType })}>Upload New File</Button>
                                        </div>
                                    </td>
                                </tr>
                                {item.files.map((file, index) =>
                                    <tr key={'opo-file-' + index}>
                                        <td></td>
                                        <td>{file.path}</td>
                                        <td>{file.uploadedOn}</td>
                                        <td>{file.uploadedByName}</td>
                                    </tr>
                                )}

                            </>
                        )}
                    </tbody>
                </Table> */}

                {list.map((item, index) =>
                    <BootstrapCard
                        title={
                            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                <div style={{ fontSize: 16 }}>{item.documentType}</div>
                                <div><Button bsStyle='primary' bsSize='sm' disabled={uploadFile.show} onClick={() => setUploadFile({ show: true, type: item.documentTypeId, typeDescription: item.documentType })}>Upload New File</Button></div>
                            </div>}
                        text={null}
                        className='opo-file'
                    >
                        {item.files.map((file, fileIndex) =>
                            <div className='row'>
                                <div className='col-xs-12 col-lg-3'>Path:</div>
                                <div className='col-xs-12 col-lg-9'>Uploaded: {file.path}</div>

                                <div className='col-xs-12 col-lg-3'>Uploaded:</div>
                                <div className='col-xs-12 col-lg-9'>{file.uploadedOn}</div>

                                <div className='col-xs-12 col-lg-3'>Uploaded By:</div>
                                <div className='col-xs-12 col-lg-9'>{file.uploadedByName}</div>
                            </div>
                        )}

                        {item.files.length == 0 && (
                            <div className='row'>
                                <div className='col-xs-12 col-lg-12'><span className='badge'>A file of this type has not been uploaded yet...</span></div>
                            </div>
                        )}

                        {uploadFile.show && uploadFile.type == item.documentTypeId && (
                            <div style={{ paddingTop: 15, display: 'flex', alignItems: 'center' }}>
                                <div style={{ width: '60%', marginRight: 5 }}>
                                    <FileUpload
                                        label={'Click here to upload a new ' + uploadFile.typeDescription.toLowerCase() + ' file...'}
                                        files={files}
                                        singleUploadOnly={true}
                                        onFileDropped={handleFileDropped}
                                        onRemoveFile={handleRemoveFile}
                                    />
                                </div>
                                <div>
                                    <Button bsStyle='primary' bsSize='xs' block disabled={files.length == 0} onClick={handleUpload}>Upload File</Button>
                                    <Button bsSize='xs' block onClick={() => setUploadFile({ show: false, type: null, typeDescription: '' })}>Cancel Upload</Button>
                                </div>
                            </div>
                        )}
                    </BootstrapCard>
                )}
            </Modal.Body>
            <Modal.Footer>
                <Button onClick={onClose}>Close</Button>
            </Modal.Footer>
        </Modal>
    );
}

export default OpoFiles;